import { FC } from 'react'

interface ChatbotOverlayProps {
  isOpen: boolean
  onClose: () => void
}

export const ChatbotOverlay: FC<ChatbotOverlayProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null

  return (
    <div
      className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 z-[10000] backdrop-blur-sm"
      style={{ display: 'flex' }}
    >
      <div className="relative w-full h-full flex justify-center items-center">
        <button
          onClick={onClose}
          className="absolute top-5 right-5 bg-white bg-opacity-20 border-none text-white text-2xl px-4 py-2 rounded-full cursor-pointer backdrop-blur-sm z-[10001] hover:bg-opacity-30 transition-all"
        >
          ✕
        </button>

        <div className="w-[95%] sm:w-[90%] md:w-[85%] lg:w-[80%] xl:w-[75%] max-w-[1200px] h-[90%] sm:h-[85%] md:h-[80%] lg:h-[85%] max-h-[800px] bg-white rounded-2xl overflow-hidden shadow-2xl">
          <iframe
            src="https://www.chatbase.co/chatbot-iframe/FEJFPXW3407sA4cKu1tA6"
            width="100%"
            height="100%"
            frameBorder="0"
            className="border-none rounded-2xl"
          />
        </div>
      </div>
    </div>
  )
}
